import { render, staticRenderFns } from "./Failures.vue?vue&type=template&id=0ed736fc"
import script from "./Failures.vue?vue&type=script&lang=js"
export * from "./Failures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports